module.exports = __webpack_public_path__ + "static/media/product_gtl.fa5e3e44.svg";